import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31c72306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amazon-warning-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "amazon-warning-title" }, "Amazon納品プラン作成にエラーが発生しました。", -1))
const _hoisted_3 = { class: "amazon-warning-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "amazon-warning-table-th" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "td" }, "エラーが発生したSKU"),
  /*#__PURE__*/_createElementVNode("div", { class: "td" }, "エラー内容")
], -1))
const _hoisted_5 = { class: "td" }
const _hoisted_6 = { class: "td" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "amazon-tip" }, "詳細原因と対処方法について、以下のリンク先をご参照ください", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "amazon-a",
  href: "https://makad.pw/wp/?p=79",
  target: "_blank"
}, " https://makad.pw/wp/?p=79 ", -1))
const _hoisted_9 = { class: "more" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon-bottom.png",
  alt: ""
}, null, -1))

import { t } from '@/plugins/i18n'
import { computed, nextTick, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'info'],
  emits: ['update:visible', 'ok', 'cancel'],
  setup(__props, { emit: emits }) {

const props = __props


const show = computed(() => props.visible)
const isMore = ref(false)
nextTick(() => {
  const height = document.querySelector('.amazon-warning-table')?.clientHeight ?? 0
  isMore.value = height > 400
  console.log(document.querySelector('.amazon-warning-table')?.clientHeight)
})
const scrollFn = (e: { scrollTop: number }) => {
  if (e.scrollTop > 10 && isMore.value) {
    isMore.value = false
  }
  if (e.scrollTop < 10 && !isMore.value) {
    isMore.value = true
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _unref(show),
    "show-close": false,
    "close-on-click-modal": false,
    "custom-class": "amazon-warning-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "iconfont icon-guanbi1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
        }),
        _hoisted_2,
        _createVNode(_component_el_scrollbar, {
          "max-height": "320px",
          height: "320px",
          onScroll: scrollFn
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.info, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "amazon-warning-table-tr",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(item?.amazonSku?.join(',')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, _toDisplayString(item?.reason), 1)
                  ])
                ]))
              }), 128)),
              _hoisted_7,
              _hoisted_8
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_unref(t)('滚动查看更多')), 1),
          _hoisted_10
        ], 512), [
          [_vShow, isMore.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})